var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pa-8" },
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.filteredLocations,
          search: _vm.search,
          loading: _vm.loading
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-toolbar",
                  { attrs: { flat: "" } },
                  [
                    _c("v-toolbar-title", { staticClass: "mr-8" }, [
                      _vm._v(
                        "\n                    Обекти \n                    " +
                          _vm._s(
                            _vm.client
                              ? 'на клиент "' + _vm.client.name + '"'
                              : ""
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: {
                        "hide-details": "",
                        "single-line": "",
                        dense: "",
                        "prepend-icon": "mdi-magnify",
                        clearable: ""
                      },
                      model: {
                        value: _vm.search,
                        callback: function($$v) {
                          _vm.search = $$v
                        },
                        expression: "search"
                      }
                    }),
                    _vm._v(" "),
                    _c("v-spacer"),
                    _vm._v(" "),
                    _c("v-select", {
                      staticClass: "mr-8",
                      staticStyle: { "max-width": "200px" },
                      attrs: {
                        "hide-details": "",
                        dense: "",
                        label: "Отдел",
                        items: _vm.departments
                      },
                      model: {
                        value: _vm.$root.department,
                        callback: function($$v) {
                          _vm.$set(_vm.$root, "department", $$v)
                        },
                        expression: "$root.department"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          fab: "",
                          color: "error",
                          dark: "",
                          to: _vm.client_id
                            ? "/clients/" + _vm.client_id + "/locations/new"
                            : "/locations/new"
                        }
                      },
                      [_c("v-icon", [_vm._v("mdi-plus")])],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item.department_id",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.departmentsById[item.department_id]) +
                    "\n        "
                )
              ]
            }
          },
          {
            key: "item.active",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(item.active ? "Да" : "Не") +
                    "\n        "
                )
              ]
            }
          },
          {
            key: "item.next_service",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.formatDate(item.next_service)) +
                    "\n        "
                )
              ]
            }
          },
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      small: "",
                      color: "primary",
                      title: "Редактиране",
                      to: "/locations/" + item.id,
                      icon: ""
                    }
                  },
                  [_c("v-icon", [_vm._v("mdi-pencil")])],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      small: "",
                      color: "primary",
                      title: "Изтриване",
                      icon: ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.remove(item.id)
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v("mdi-trash-can")])],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }